<div class="main-container-syncing" *ngIf="appService.theme$ | async as theme">
    <div class="spinner-container" 
    [style]="{'background': theme === 'light' ? 'var(--surface-0)' : 'var(--bg-secondary)'}">
        <p-progressSpinner
            [style]="{width: '44px', height: '44px'}" 
            styleClass="progressSpinner"
            strokeWidth="2"  
            animationDuration=".5s"
             />
        <button class="cancel-button" (click)="cancelRequest()"
        [style]="{
            'background': theme === 'light' ? 'var(--button-primary)' : 'transparent',
            'color' : theme === 'light' ? 'var(--surface-0)' : 'var(--button-primary)'}">Cancel</button>
        <!-- <h4 style="color: #e7e7e7">Loading...</h4> -->
    </div>
</div>